<template>
  <div v-if="pack">
    <v-dialog v-model="value" max-width="800" persistent>
      <v-card>
        <v-card-title class="headline font-weight-thin">
          <div>
            <strong data-cy="label">{{ pack.title }}</strong>
          </div>
        </v-card-title>

        <v-card-title class="mt-n5">
          <div class="subtitle-1" data-cy="releaseNoteCountMessage">{{ releaseNoteList.length }} Release Note(s)</div>
        </v-card-title>
        <v-card-text>
          <router-link :to="`/pack/${pack.id}/releaseNote/list`">View Release Note Summary List</router-link>
        </v-card-text>
        <v-card-text>
          <release-note-list-dialog-table :releaseNoteList="releaseNoteList"></release-note-list-dialog-table>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn @click="close" class="mr-2" outlined>Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ReleaseNoteListDialogTable from "@/components/ReleaseNoteListDialogTable.vue";

export default {
  components: {
    ReleaseNoteListDialogTable,
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
  },
  props: {
    releaseNoteList: { required: true, type: Array },
    pack: { required: false, type: Object },
    value: { required: true, type: Boolean },
  },
};
</script>
